/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import getConfig from '../config';

export default class GMOData {
	dunamisToGMOData(data, action) {
		// /ss to see analytics in browser
		//	this.getLocation();
		let attempts = 0;
		let property;
		const digitalData = window.digitalData;

		// if digitalData is undefined, we stop the execution of this script
		if (!digitalData) {
			if (!attempts) {
				attempts++;
				setTimeout(() => {
					this.dunamisToGMOData(data, action);
				}, 500);
			}
			return;
		}

		digitalData._set('digitalData.page.pageInfo.issueDate', getConfig('APP_VERSION'));
		const map = {
			// event
			'event.guid': 'primaryEvent.eventInfo.id',
			// 'event.dts_start': 'primaryEvent.eventInfo.start',
			'event.dts_end': 'primaryEvent.eventInfo.end',
			'event.workflow': 'primaryEvent.category.primaryCategory',
			'event.subcategory': 'primaryEvent.category.subCategory',
			'event.type': 'primaryEvent.eventInfo.type',
			'event.subtype': 'primaryEvent.eventInfo.subtype',
			'event.link_type': 'o', // Haresh's request to fix dup renders
			'event.language': 'digitalData.page.pageInfo.language', // should be able to use digitalData.page.pageInfo.language
			// 'event.build': 'app.appInfo.build',
			'source.name': 'primaryComponent.componentInfo.name',
			'source.version': 'primaryComponent.componentInfo.version',
		};

		const eventsArray = data[0].events;

		eventsArray.forEach((event) => {
			for (property in event.data) {
				// eslint-disable-next-line no-prototype-builtins
				if (!event.data.hasOwnProperty(property)) {
					continue;
				}

				// if we have data for that property and
				// if the property is one that we care about and it mapped
				if (event.data[property] && map[property]) {
					// set it on the data layer
					digitalData._set(map[property], event.data[property]);
				}
			}

			if (action === 'click') {
				// set the eventName
				digitalData._set(
					'primaryEvent.eventInfo.eventName',
					[
						event.data['source.name'],
						event.data['source.version'],
						event.data['event.category'],
						event.data['event.subcategory'],
						event.data['event.type'],
						event.data['event.subtype'],
						event.data['event.workflow'],
					].join(':'),
				);

				window._satellite.track('event', {
					digitalData: digitalData._snapshot(),
				});
			}
			else {
				window._satellite.track('state', {
					digitalData: digitalData._snapshot(),
				});
			}

			digitalData._delete('primaryComponent');
		});
	}

	getLocation() {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(() => {});
		}
	}
}
